module.exports = __webpack_public_path__ + "img/survey.c40aa7a4.png";